import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'
import styled, { css } from 'styled-components'
import { TAbsolutePosition } from './types'

interface ITogglerWrapperProps {
  $isToggled: boolean
  $absolutePosition?: TAbsolutePosition
  $size?: 'small' | 'medium' | 'large' | { width: number; height: number }
  $wrapped?: boolean
}

const getTogglerSize = (
  size?: ITogglerWrapperProps['$size']
): { width: string; height: string } => {
  if (typeof size === 'object' && size !== null) {
    return { width: `${size.width}px`, height: `${size.height}px` }
  }
  const px = size === 'small' ? '24px' : '32px'
  return { width: px, height: px }
}

const getAbsolutePositionStyles = ({
  absolutePosition
}: {
  absolutePosition?: TAbsolutePosition
}) => {
  if (!absolutePosition) return ''

  const { top, left, right, bottom } = absolutePosition ?? {}
  return css`
    position: absolute;
    top: ${top ? `${top}px` : 'unset'};
    left: ${left ? `${left}px` : 'unset'};
    right: ${right ? `${right}px` : 'unset'};
    bottom: ${bottom ? `${bottom}px` : 'unset'};
  `
}

const activeWrapperStyles = css`
  border-color: ${COLORS.secondary};
  background-color: ${COLORS.primaryLight};
  & > svg {
    fill: ${COLORS.secondaryDark};
  }
`
export const TogglerWrapper = styled.div<ITogglerWrapperProps>`
  z-index: 2;

  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $size }) => {
    const { width, height } = getTogglerSize($size)
    return css`
      width: ${width};
      height: ${height};
    `
  }}
  background-color: ${COLORS.white};
  border-radius: ${RADII.item};

  ${({ $wrapped }) =>
    $wrapped &&
    css`
      border: 1px solid ${COLORS.secondarySemiLight};
    `}

  cursor: pointer;

  ${({ $absolutePosition }) =>
    getAbsolutePositionStyles({ absolutePosition: $absolutePosition })}

  & > svg {
    border-radius: ${RADII.item};
    fill: ${COLORS.secondarySemiDark};
  }

  ${({ $isToggled }) => $isToggled && activeWrapperStyles}

  @media only screen and (min-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT + 1}px) {
    &:hover {
      ${activeWrapperStyles}
    }
    transition: 0.2s ease-in-out;
  }
`
